/* eslint-disable max-len */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StyledCalendar } from '../Calendar'

import { brueckendeckUrl, sonnendeckUrl, inselgartenUrl, theaterdeckUrl } from '../../../config/website'
import { compareDates } from '../../utils/time'

const CalendarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: white;

  .react-calendar {
    margin-top: 0;
  }

  .react-calendar__tile--active {
    &:before,
    &:after {
      display: none;
    }
  }
`

class FormCalendar extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dates: []
    }
  }

  componentDidMount () {
    const brueckendeckRequest = fetch(brueckendeckUrl).then(response => response.json())
    const inselgartenRequest = fetch(inselgartenUrl).then(response => response.json())
    const sonnendeckRequest = fetch(sonnendeckUrl).then(response => response.json())
    const theaterdeckRequest = fetch(theaterdeckUrl).then(response => response.json())

    Promise.all([brueckendeckRequest, inselgartenRequest, sonnendeckRequest, theaterdeckRequest]).then(values => {
      const result = values.reduce((accumulator, current) => {
        if (current.items) {
          current.items.forEach(item => {
            accumulator.push({
              room: current.summary,
              start: item.start.date,
              end: item.end.date
            })
          })
        }

        return accumulator
      }, [])

      this.setState({
        dates: result
      })
    })
      .catch(err => {
        console.log('Fetch Error:', err)
      })
  }

  getAvailability = (selectedDate, room) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false
    }

    return this.state.dates.filter(entry => compareDates(entry.start, entry.end, selectedDate) && entry.room === room).length > 0
  }

  checkDisabled = ({ activeStartDate, date, view }) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false
    }

    if (new Date(date).getDay() === 0) {
      return true
    }

    return this.state.dates.filter(entry => compareDates(entry.start, entry.end, date)).length >= 4
  }

  onSelect = selectedDate => {
    if (this.props.onSelectDate) {
      this.props.onSelectDate(selectedDate, {
        inselgarten: this.getAvailability(selectedDate, 'Wiese'),
        sonnendeck: this.getAvailability(selectedDate, 'Sonnendeck'),
        brueckendeck: this.getAvailability(selectedDate, 'Brückendeck'),
        theaterdeck: this.getAvailability(selectedDate, 'Theater')
      })
    }
  }

  render () {
    const { calendarLimit } = this.props
    return (
      <CalendarContainer>
        <StyledCalendar
          locale="de-DE"
          next2Label={null}
          prev2Label={null}
          showNeighboringMonth={true}
          showFixedNumberOfWeeks={true}
          minDate={new Date()}
          maxDate={new Date(calendarLimit)}
          minDetail={'month'}
          selectRange={false}
          tileDisabled={this.checkDisabled}
          onClickDay={this.onSelect}
        />
      </CalendarContainer>
    )
  }
}

FormCalendar.propTypes = {
  // siteTitle: PropTypes.string,
  // currentPathname: PropTypes.string,
}

FormCalendar.defaultProps = {
  // siteTitle: ``,
}

export default FormCalendar
